import { action, observable } from 'mobx';
import Api from '../../api';
import UserPreferences from '../../domain/entities/UserPreferences/UserPreferences';
import { PRIVACY_POLICY } from '../../constants/Constants';
import STATUS from '../../constants/Status';

export interface IUserPreferenceRepositoryConfig {
  api: Api;
  userPreferences: UserPreferences;
}

class UserPreferencesRepository {
  @observable status = STATUS.IDLE;

  private api: Api;

  public userPreferences: UserPreferences;

  public isSubscribed = false;

  constructor(config: IUserPreferenceRepositoryConfig) {
    this.api = config.api;
    this.userPreferences = config.userPreferences;
  }

  @action
  setStatus(status: STATUS): void {
    this.status = status;
  }

  @action
  async loadSubscription(): Promise<void> {
    if (this.status === STATUS.IDLE || this.status === STATUS.ERROR) {
      try {
        this.setStatus(STATUS.LOADING);
        const resp = await this.api.getSubscription();
        const { newsletterSubscribed } = resp;
        this.userPreferences = UserPreferences.fromJSON({
          subscribed: newsletterSubscribed,
        });
        this.isSubscribed = newsletterSubscribed;
        this.setStatus(STATUS.LOADED);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.setStatus(STATUS.ERROR);
      }
    }
  }

  @action
  updateSubscription = (userPreferences: UserPreferences): void => {
    this.api.setSubscription(Number(userPreferences.subscribed));
    this.userPreferences = userPreferences;
    this.isSubscribed = userPreferences.subscribed;
  };

  @action
  async updateAcceptedState(userPreferences: UserPreferences): Promise<void> {
    await this.api.setAcceptedPrivacyPolicy(userPreferences.acceptedPrivacyPolicy
      ? PRIVACY_POLICY.ACCEPTED : PRIVACY_POLICY.REJECTED);
  }
}

export default UserPreferencesRepository;
